<template>
  <el-dialog
    :title="$t('text.invite_user')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="true"
    :modal-append-to-body="true"
    :append-to-body="true"
    @close="closeDialog()"
    width="400px"
    class="edit-group"
  >
    <InviteUser @sendSuccessfully="closeDialog" />
  </el-dialog>
</template>

<script>
import InviteUser from '@/components/manage/user/InviteUser.vue'
export default {
  data() {
    return {
      dialogVisible: false
    }
  },
  components: {
    InviteUser
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
    }
  }
}
</script>
